import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {JhiLoginModalComponent} from 'src/app/shared/login/login.component';
import {errorRoute,navbarRoute} from './layouts';



const LAYOUT_ROUTES = [navbarRoute, ...errorRoute];



@NgModule({
    imports: [
        RouterModule.forRoot(
            [ 
                ...LAYOUT_ROUTES,
             //   ...SpotShipmentDeclarationRoute,
                {
                    path: 'admin',
                    loadChildren: './admin/admin.module#TdisstudioAdminModule'
                },
                {
                    path: 'dashboard',
                    loadChildren: './home/home.module#TdisstudioHomeModule'
                },
                {
                    path: 'account',
                    loadChildren: './account/account.module#TdisstudioAccountModule'
                },
                {
                    path: 'verify-certificate',
                    loadChildren: './account/verify-certificate.module#TdisstudioVerifyCertificateModule'
                },
                {
                    path: 'instructions',
                    loadChildren: './account/instruction.module#TdisstudioInstructionModule'
                },
                {
                    path: 'reset',
                    loadChildren: './account/password-reset.module#TdisstudioPasswordResetModule'
                },
                {
                    path: 'certificate',
                    loadChildren: './client/certificate.module#TdisstudioCertificateModule'
                },
                {
                    path: 'my-open-policy',
                    loadChildren: './client/client.module#ClientModule'
                },
                {
                    path: 'policy',
                    loadChildren: './entities/policy-my-suffix/policy-my-suffix.module#TdisstudioPolicyMySuffixModule'
                },
                { 
                    path: 'scope-my-suffix',
                    loadChildren: './entities/scope-my-suffix/scope-my-suffix.module#TdisstudioScopeMySuffixModule'
                },
                {
                    path: 'rule-my-suffix',
                    loadChildren: './entities/rule-my-suffix/rule-my-suffix.module#TdisstudioRuleMySuffixModule'
                },
                {
                    path: 'sub-rule-my-suffix',
                    loadChildren: './entities/sub-rule-my-suffix/sub-rule-my-suffix.module#TdisstudioSubRuleMySuffixModule'
                },

                {
                    path: 'storage-rule-my-suffix',
                    loadChildren: './entities/storage-rule-my-suffix/storage-rule-my-suffix.module#TdisstudioStorageRuleMySuffixModule'
                },
                {
                    path: 'loss-payee',
                    loadChildren: './entities/loss-payee-my-suffix/loss-payee-my-suffix.module#TdisstudioLossPayeeMySuffixComponentModule'
                },
                {
                    path: 'storage-declaration-my-suffix',
                    loadChildren: './entities/storage-insurance-declare-my-suffix/storage-insurance-declare-my-suffix.module#TdisstudioStorageDeclarationMySuffixModule'
                },
                {
                    path: 'accounting',
                    loadChildren: './entities/accounting-my-suffix/accounting-my-suffix.module#TdisstudioAccountingMySuffixComponentModule'
                },
                {
                    path: 'my-declaration',
                    loadChildren: './entities/bulk-declaration/bulk-declaration.module#BulkDeclarationModule'
                },
                {
                    path: 'user-management',
                    loadChildren: './entities/user-management/user-management.module#TdisUserManagementModule'
                }, 
                {
                    path: 'data-management',
                    loadChildren: './entities/data-management.module#TdisstudioDataManagementModule'
                },
                {
                    path: 'notification',
                    loadChildren: './entities/notifications-my-suffix/notifications-my-suffix.module#TdisstudioNotificationsMySuffixComponentModule'
                },
                {
                    path: 'certificate-client',
                    loadChildren: './entities/certificate-client/certificate-client.module#CertificateClientMySuffixModule'
                },
                {
                    path: 'future-record-details',
                    loadChildren: './entities/future-record-status/future-record-status.module#TdisstudioFutureRecordStatusModule'
                },
                
                {
                    path: 'billing',
                    loadChildren: './entities/billing/billing.module#BillingModule'
                },

                {
                    path: 'block-chain',
                    loadChildren: './entities/block-chain-my-suffix/block-chain-my-suffix.module#TdisstudioBlockChainMySuffixModule'
                },


                {
                    path: 'claim',
                    loadChildren: './client/claims/claim.module#TdisstudioClaimModule'
                },
                {
                    path: 'claimant',
                    loadChildren: './account/register-claimant/claimant.module#TdisstudioClaimantModule'
                },
                {
                    path:'spot-certificate',
                    loadChildren:'./shared/spot-certificate/spot-certificate-my-suffix.module#TdisstudioSpotCertificateMySuffixComponentModule'
                },
                
                {
                    path:'spot_client',
                    loadChildren:'./shared/spot-client/spot-client-my-suffix.module#TdisstudioSpotClientMySuffixComponentModule'
                },
                {
                    path: 'features',
                    loadChildren: './shared/features/fetures.module#TdisstudioFeaturesModule'
                },

                //login  
                { path: 'login', component: JhiLoginModalComponent, pathMatch: 'full' },
                { path: '', component: JhiLoginModalComponent, pathMatch: 'full' },

            ],
            { useHash: true}
        )
    ],
    exports: [RouterModule]
})
export class TdisstudioAppRoutingModule {}
